const map = {
  namespaced: true,
  state: {
    local: {}
  },
}

export default map



// WEBPACK FOOTER //
// ./src/vuex/modules/map.js